import React, { useState } from 'react';
import { getEligibleNewAdmins } from '../utils/groupPermissions';
import config from '../config';
import '../styles/AdminLeaveGroupModal.css';

const AdminLeaveGroupModal = ({ group, user, onCancel, onConfirm, loading }) => {
  const candidates = getEligibleNewAdmins(group, user.id);
  const [selectedId, setSelectedId] = useState(
    candidates.length === 1 ? (candidates[0].user?._id || candidates[0].user).toString() : ''
  );

  const handleConfirm = () => {
    if (!selectedId) return;
    onConfirm(selectedId);
  };

  return (
    <div className="gm-confirmation-overlay admin-leave-overlay" onClick={onCancel}>
      <div
        className="gm-confirmation-modal admin-leave-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="gm-confirmation-title">Leave Group</h3>
        <p className="gm-confirmation-message">
          As group admin, choose a member to become the new admin before you leave. They will
          receive full admin control immediately.
        </p>

        <div className="admin-leave-member-list">
          {candidates.length === 0 ? (
            <p className="admin-leave-empty">Add another member to the group before leaving.</p>
          ) : (
            candidates.map((member) => {
              const memberUser = member.user;
              const memberId = (memberUser._id || memberUser).toString();
              const isSelected = selectedId === memberId;
              return (
                <button
                  key={memberId}
                  type="button"
                  className={`admin-leave-member-option ${isSelected ? 'selected' : ''}`}
                  onClick={() => setSelectedId(memberId)}
                >
                  <span className="admin-leave-radio" aria-hidden="true" />
                  <span className="admin-leave-avatar">
                    {memberUser.profileImage ? (
                      <img
                        src={`${config.apiUrl}${memberUser.profileImage}`}
                        alt=""
                      />
                    ) : (
                      <span className="admin-leave-avatar-placeholder notranslate">
                        {memberUser.username?.charAt(0).toUpperCase()}
                      </span>
                    )}
                  </span>
                  <span className="admin-leave-name notranslate">{memberUser.username}</span>
                </button>
              );
            })
          )}
        </div>

        <div className="gm-confirmation-actions">
          <button type="button" className="gm-cancel-button" onClick={onCancel} disabled={loading}>
            Cancel
          </button>
          <button
            type="button"
            className="gm-confirm-button"
            onClick={handleConfirm}
            disabled={loading || !selectedId || candidates.length === 0}
          >
            {loading ? 'Leaving...' : 'Confirm & Leave'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLeaveGroupModal;
